import React from "react";
import { useCustomer } from "../../hooks/useCustomers";

interface CustomerNameProps {
  customerId: string;
  fallback?: string;
  showEmail?: boolean;
  showPlayerId?: boolean;
}

export const CustomerName: React.FC<CustomerNameProps> = ({
  customerId,
  fallback = "Unknown Customer",
  showEmail = false,
  showPlayerId = false,
}) => {
  const { data: customerDetail, isLoading, isError } = useCustomer(customerId);
  const customer = customerDetail?.customer;

  if (isLoading) {
    return <div className="text-slate-400 text-sm">Loading...</div>;
  }

  if (isError || !customer) {
    return (
      <div className="text-slate-400 text-sm">
        <div>{fallback}</div>
        <div className="text-xs text-slate-500">ID: {customerId}</div>
      </div>
    );
  }

  return (
    <div className="text-white text-sm">
      <div>{customer.name}</div>
      {showEmail && customer.email && (
        <div className="text-xs text-slate-400">{customer.email}</div>
      )}
      {showPlayerId && customer.playerId && (
        <div className="text-xs text-slate-400">
          Player: {customer.playerId}
        </div>
      )}
    </div>
  );
};
